var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDefectCreated(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 16,
    viewBox: "0 0 20 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.48.675c.895-.896 2.316-.9 3.189-.01l.368.374c.873.886.873 2.322.003 3.207L13.577 9.81a2.23 2.23 0 0 1-1.12.617l-2.647.536a.643.643 0 0 1-.678-.177.767.767 0 0 1-.202-.69l.558-2.7c.086-.425.266-.844.594-1.127L15.48.675zm2.14 1.059a.735.735 0 0 0-1.056.003l-.644.665 1.415 1.441.653-.693c.29-.268.29-.746 0-1.041l-.369-.375zm-6.678 5.975-.325 1.565 1.536-.327c.14-.032.27-.101.371-.205l3.761-3.83-1.408-1.434L11.14 7.33a.745.745 0 0 0-.198.379zm-2.77-3.806c.412 0 .743.337.743.756a.748.748 0 0 1-.743.756H2.23a.749.749 0 0 0-.743.756v7.56c0 .42.333.757.743.757H15.6a.748.748 0 0 0 .743-.756V9.699c0-.418.331-.756.743-.756s.743.338.743.756v4.033c0 1.254-.997 2.268-2.229 2.268H2.23C.998 16 0 14.986 0 13.732v-7.56c0-1.255.998-2.269 2.229-2.269h5.943zm-5.2 6.049a.998.998 0 0 1 .99-1.009c.548 0 .99.45.99 1.009a.998.998 0 0 1-.99 1.008.998.998 0 0 1-.99-1.008zm4.952 0a.998.998 0 0 1-.99 1.008.998.998 0 0 1-.99-1.008.998.998 0 0 1 .99-1.009c.548 0 .99.45.99 1.009z",
    fill: "#D23B3B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefectCreated);
export default __webpack_public_path__ + "static/media/defect_created.a32531e9eb67fb2eb4f42e025dc9cd3b.svg";
export { ForwardRef as ReactComponent };